import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=72ee2fb5"
import script from "./profile.vue?vue&type=script&lang=ts"
export * from "./profile.vue?vue&type=script&lang=ts"
import style0 from "./profile.vue?vue&type=style&index=0&id=72ee2fb5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports